import {
  Routes,
  Route,
} from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import Menu from './components/Menu/Menu';
import Management from './components/Management/Management';
import Ticket from './components/Ticket/Ticket';
import Reporting from './components/Reporting/Reporting';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

import './App.css';
import './assets/css/owl-coursel/owl.carousel.css';
import './assets/css/owl-coursel/owl.theme.css';
import './assets/css/magnific-popup/magnific-popup.css';
import './assets/css/bootstrap.css';
import './assets/css/font-awesome.min.css';
import './assets/css/style.css';
import './assets/css/responsive.css';

function App() {
  return (
    <div className="App">
      <ScrollToTop/>
        <Header/>
        <div >
          <Routes>
            <Route path="/" element={<Home />}/>
            <Route path="/Menu" element={<Menu />}/>
            <Route path="/Management" element={<Management />}/>
            <Route path="/Ticket" element={<Ticket />}/>
            <Route path="/Reporting" element={<Reporting />}/>
            <Route path="/Contact" element={<Contact />}/>
          </Routes>
        </div>
        <Footer/>
      </div>
  );
}

export default App;
